import { parseQueryString, toQueryString } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const languages = () => {
  (function ($) {
    const $select = $('.js-select');
    const $languages = $('.c-languages');
    const $navigation = $('.c-navigation');
    const $placeholder = $('.c-languages__placeholder');
    const $list = $('.c-languages__list');
    const $listOpen = 'c-languages__list--open';
    const $link = $('.c-languages__list-link');
    const $wrapper = $('.c-languages__wrapper');
    const isActive = 'c-languages__wrapper--open';
    const langCodes = drupalSettings.languages;

    const links = $link.toArray().map(item => ({
      flag: $(item).data('flag'),
      label: $(item).text().trim(),
      params: $(item).data('drupal-link-query'),
      get code() {
        try{
          return langCodes[this.label];
        }catch (err){
          console.log(err);
        }
      },
    }));

    /**
     * Set the language in the DOM list without refreshing the page
     * @param {string} code language code
     */
    const setLanguage = (code) => {
      const set = links.find((item) => {
        // if the supplied code is a label
        if (code === item.label) {
          return code === item.label;
        }

        return code === item.code;
      }) || null;

      if (!set) {
        // console.log(code, set, links);
        return;
      }

      const $linkValue = set.label;
      const $flagSelected = set.flag;
      // const $placeholderModifier = $placeholder.attr('class').split(' ')[1];

      // $placeholder.removeClass($placeholderModifier);
      $placeholder.text($linkValue);
      $placeholder.addClass($flagSelected);
      $list.removeClass($listOpen);
      // console.log(`Language set to ${set.label}`);
    };

    // set language in menu to selected language
    setLanguage($('html').attr('lang'));

    $navigation.append($languages);

    // const isDesktop = $window.width() >= 1024;
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    // open the language list on click
    $select.on('click', (e) => {
      e.preventDefault();
      $list.toggleClass($listOpen);

      if (isDesktop) {
        $wrapper.toggleClass(isActive);
      }
    });
    // // set the language on click
    // $link.on('click', (e) => {
    //   e.preventDefault();
    //   const $target = $(e.target);
    //   const label = $target.text().trim();
    //   const queryObject = Object.assign(
    //     parseQueryString(window.location.search),
    //     { language: langCodes[label] },
    //   );
    //   const { origin, search, href } = window.location;
    //
    //   // the absolute path excluding url parameters
    //   let url = href.replace(origin, '').replace(search, '');
    //
    //   setLanguage(label);
    //   if (langCodes[label] === 'zh-hans') {
    //     // update query object with new params and refresh the page
    //     // console.log('add cn');
    //     url = href.indexOf('/cn') === -1 ? `/cn${url}` : url;
    //     // console.log(url);
    //     window.location.href = `${origin}${url}${toQueryString(queryObject)}`;
    //   } else {
    //     // console.log('remove cn');
    //     if (langCodes[label] !== 'zh-hans') {
    //       // remove 'cn' from the url if it exists
    //       url = url.replace('/cn', '');
    //       // console.log(url);
    //       window.location.href = `${origin}${url}${toQueryString(queryObject)}`;
    //     }
    //   }
    //   window.location.href = `${origin}${url}${toQueryString(queryObject)}`;
    //
    //   if (isDesktop) {
    //     $wrapper.removeClass(isActive);
    //   }
    // });
  }(jQuery));
};

export default languages;
